<template>
FastApi
  <div>
    <p>{{ msg }}</p>
  </div>
</template>

<script>
import axios from '@/api/client';

export default {
  name: 'FastApiPing',
  data() {
    return {
      msg: '',
    };
  },
  methods: {
    getMessage() {
      axios.get('/')
        .then((res) => {
          this.msg = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.getMessage();
  },
};
</script>